export default __webpack_public_path__ + "static/media/callMissed.aad501d1.svg";